import { render, staticRenderFns } from "./SettingBenhAn.vue?vue&type=template&id=1b3569cd&scoped=true"
import script from "./SettingBenhAn.vue?vue&type=script&lang=js"
export * from "./SettingBenhAn.vue?vue&type=script&lang=js"
import style0 from "./SettingBenhAn.vue?vue&type=style&index=0&id=1b3569cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3569cd",
  null
  
)

export default component.exports